import { render, staticRenderFns } from "./ShortcutWrapper.vue?vue&type=template&id=78d5d270&"
import script from "./ShortcutWrapper.vue?vue&type=script&lang=js&"
export * from "./ShortcutWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports